// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width: 768px) {\n  .top-keywords-overview .top-keywords-overview-box .ant-statistic-title {\n    font-size: 12px;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
